// import Alpine from '../../vendor/livewire/livewire/dist/livewire.esm';

import processingPayment from "./processingPayment";
import verificationCode from "./verificationCode";
import virtualScroll from "./virtualScroll";
import scrollTable from "./scrollTable";
import registrationPackages from "./registrationPackages";
import screenModal from "./screenModal";
import savedPhotos from "./savedPhotos";
import packageArea from "./packageArea";
import packages from "./packages";
import payment from "./payment";
import cart from "./cart";
import quickCheckout from "./quickCheckout";
import sharePhotos from "./sharePhotos";
import './checkout-wizard';

Alpine.data("processingPayment", processingPayment);
Alpine.data("verificationCode", verificationCode);
Alpine.data("virtualScroll", virtualScroll);
Alpine.data("savedPhotos", savedPhotos);
Alpine.data("packageArea", packageArea);
Alpine.data("screenModal", screenModal);
Alpine.data("scrollTable", scrollTable);
Alpine.data("registrationPackages", registrationPackages);
Alpine.data("packages", packages);
Alpine.data("payment", payment);
Alpine.data("cart", cart);
Alpine.data("quickCheckout", quickCheckout);
Alpine.data("sharePhotos", sharePhotos);
